import { render, staticRenderFns } from "./GeoradarPointsList.vue?vue&type=template&id=8f6f5c0e&lang=pug"
import script from "./GeoradarPointsList.vue?vue&type=script&lang=js"
export * from "./GeoradarPointsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports